'use client'

import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useWizardStore } from '@repo/store/useWizardStore'

const EmptyComponent = () => null

export const WizardStepContents = ({ currentStep, wideMode, handlePrevNext, wizardId, changeWizard, uniqueStepId }) => {
  const { wizardState, setWizardState } = useWizardStore()

  const currentStepId = currentStep?.uniqueId

  const currentStepState = currentStepId ? wizardState[currentStepId] : null
  const Component = currentStep?.component || EmptyComponent

  useEffect(() => {
    if (!currentStepState) setWizardState({ key: currentStepId, value: { currentStepId } })
  }, [setWizardState, currentStepState, currentStepId])

  const updateStepState = (changes) => {
    setWizardState({ key: currentStepId, value: { ...currentStepState, ...changes } })
  }

  return (
    <div
      data-testid="WizardStepContents"
      style={{
        width: '100%'
      }}
    >
      <Component
        updateStepState={updateStepState}
        wideMode={wideMode}
        currentStep={currentStep}
        handlePrevNext={handlePrevNext}
        wizardId={wizardId}
        changeWizard={changeWizard}
        uniqueStepId={uniqueStepId}
      />
    </div>
  )
}

WizardStepContents.propTypes = {
  currentStep: PropTypes.object,
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func,
  wizardId: PropTypes.string,
  changeWizard: PropTypes.func,
  uniqueStepId: PropTypes.string
}
